import styled from "styled-components";

export const HyperLink = styled.a`
  align-items: center;
  display: inline-flex;
  text-decoration: none;
  transition: 150ms ease-in-out;
  position: relative;
  transition: color 150ms ease-in-out;
  color: #6f6c90;
  overflow: hidden;
  margin-right: 1rem;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  &:hover {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: none;

    &:after {
      transition: transform 150ms ease-in-out;
      transform: translateX(0);
    }
  }

  ::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 0.1rem;
    bottom: 0;
    left: 0;
    background-color: ${(props) => props.theme.colors.primary};
    transform: translateX(-100%);
  }
`;
